<template>
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-lightborder table-hover">
      <thead>
        <tr>
          <th>CUI</th>
          <th>Fecha inicio</th>
          <th>Fecha Fin</th>
          <th>Nombre de persona</th>
          <th>Tipo oferta</th>
          <th>lista Precio</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
          @click="
            rowClick('cat-cupones-apl-editar', {
              id: current.id,
            })
          "
        >
          <td>{{ current.id }}</td>
          <td>{{ current.fecha_inicio | moment("YYYY-MM-DD hh:mm") }}</td>
          <td>{{ current.fecha_fin | moment("YYYY-MM-DD hh:mm") }}</td>
          <td>{{ current.nombre }}</td>
          <td><span v-if="current.tipo_oferta == 'I'">INTERNO</span>
          <span v-if="current.tipo_oferta == 'E'">EXTERNO</span></td>
          <td>{{ current.lista_precio_obj.id }} - {{ current.lista_precio_obj.nombre }}</td>
          <td class="text-center" v-if="current.estatus == true">
            <span class="badge badge-sm badge-success">Activo</span>
          </td>
          <td class="text-center" v-if="current.estatus == false">
            <span class="badge badge-sm badge-danger">Inactivo</span>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
export default {
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  props: ["dataTabla"],
  mounted() {},
  methods: {
    rowClick(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: name,
          params: params,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$router.push({
          name: name,
          params: params,
        });
      }
    },
  },
};
</script>
